'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    LoginController.$inject = ['$rootScope', '$state', 'authService'];
    angular.module('app.admin').component('login', {
        template: '<style>\n\n.login-form {\n  margin: 0 auto;\n  width: 330px;\n}\n\n.login-form h3 {\n  margin-bottom: 15px;\n}\n\n.login-form .btn {\n  margin-top: 30px;\n}\n\n</style><div class="container"><div class="modal-body" translate-namespace="admin.login"><div class="login-form"><h3 class="modal-title text-center" translate>.Sign in</h3><div class="alert alert-danger" role="alert" ng-if="$ctrl.hasError" translate>.Sorry, we could not log you in.</div><div class="form-group"><label for="email" translate>.Email address</label> <input type="email" class="form-control" id="email" ng-click="$ctrl.resetErrors()" ng-model="$ctrl.email" translate-attr-placeholder=".Email address"></div><div class="form-group"><label for="password" translate>.Password</label> <input type="password" class="form-control" id="password" ng-click="$ctrl.resetErrors()" ng-model="$ctrl.password" translate-attr-placeholder=".Password"></div><button class="btn btn-lg btn-default btn-block" type="submit" ng-click="$ctrl.onLogin()" translate>.Sign in</button></div></div></div>',
        controller: LoginController,
        controllerAs: '$ctrl'
    });

    function LoginController($rootScope, $state, authService) {
        'ngInject';

        var $ctrl = this;

        $ctrl.email = '';
        $ctrl.password = '';

        $ctrl.hasError = false;

        ////////////////

        $ctrl.$onInit = function () {};
        $ctrl.$onChanges = function (changesObj) {};
        $ctrl.$onDestroy = function () {};

        $ctrl.onLogin = function () {
            authService.login($ctrl.email, $ctrl.password).then(function (user) {
                $rootScope.$emit('user.login', user);

                if (user.email === 'parking.mngr@smartcity.heraklion.gr') {
                    $state.go('parking');
                } else {
                    $state.go('dashboard');
                }
            }).catch(function (error) {
                $ctrl.hasError = true;
            });
        };

        $ctrl.resetErrors = function () {
            $ctrl.hasError = false;
        };
    }
})();